var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const VTP_FINANCING_NC = {};
const VTP_FINANCING_UC = {};
const storeMap = { VTP_FINANCING_NC, VTP_FINANCING_UC };
export function readFinance(storeName) {
    return __awaiter(this, void 0, void 0, function* () {
        if (typeof window !== 'undefined') {
            const storageData = sessionStorage.getItem(storeName);
            try {
                return JSON.parse(storageData);
            }
            catch (e) {
                console.error('Failed to parse session storage data', e);
                return null;
            }
        }
        return null;
    });
}
const saveFinancingSession = (storeName, payload) => {
    if (typeof window !== 'undefined') {
        sessionStorage.setItem(storeName, JSON.stringify(payload));
    }
    else {
        storeMap[storeName] = Object.assign({}, payload);
    }
};
export function updateFinanceInStore(vehicleId, storeName, requestData, result) {
    return __awaiter(this, void 0, void 0, function* () {
        const financeFromStore = yield readFinance(storeName);
        const financingData = (financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing) ? financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing[vehicleId] : {};
        const obj = {
            financing: Object.assign(Object.assign({}, financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing), { [vehicleId]: Object.assign(Object.assign({}, financingData), { financeRequestData: requestData ? Object.assign({}, requestData) : undefined, financeResponseData: result ? Object.assign({}, result) : undefined }) }),
        };
        saveFinancingSession(storeName, obj);
    });
}
export function saveFinanceInStore(vehicleId, storeName, financingStore) {
    return __awaiter(this, void 0, void 0, function* () {
        const financeFromStore = yield readFinance(storeName);
        const financingData = (financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing) ? financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing[vehicleId] : {};
        const obj = {
            financing: Object.assign(Object.assign({}, financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing), { [vehicleId]: Object.assign(Object.assign({}, financingData), financingStore) }),
        };
        saveFinancingSession(storeName, obj);
    });
}
export function saveCampaignInStore(vehicleId, storeName, campaign) {
    return __awaiter(this, void 0, void 0, function* () {
        const financeFromStore = yield readFinance(storeName);
        const financingData = (financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing) ? financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing[vehicleId] : {};
        const obj = {
            financing: Object.assign(Object.assign({}, financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing), { [vehicleId]: Object.assign(Object.assign({}, financingData), { campaign: campaign ? Object.assign({}, campaign) : {} }) }),
        };
        saveFinancingSession(storeName, obj);
    });
}
export function saveProductInStore(vehicleId, storeName, rawProduct, defaultProductData) {
    return __awaiter(this, void 0, void 0, function* () {
        const financeFromStore = yield readFinance(storeName);
        const financingData = (financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing) ? financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing[vehicleId] : {};
        const obj = {
            financing: Object.assign(Object.assign({}, financeFromStore === null || financeFromStore === void 0 ? void 0 : financeFromStore.financing), { [vehicleId]: Object.assign(Object.assign({}, financingData), { defaultResponse: { Response: rawProduct }, defaultProductData }) }),
        };
        saveFinancingSession(storeName, obj);
    });
}
